import React, { useState, useEffect } from "react";
import "./productTraining.scss";
import Footer from "../../component/Footer/Footer";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import { useNavigate } from "react-router-dom";
import ProductTrainings from "../../component/ProductTrainingComponent/ProductTraining";
import Module from "../../component/TroubleShootingComponent/Module";
import { tutorialListAction } from "../../actions/trainingAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { safeEncode } from "../../common/encoder";
import { moduleListAction } from "../../actions/moduleListAction";
import { NotificationManager } from "react-notifications";
import Pagination from "../../component/Pagination/PgmTextField";
import Modulepagination from "../../component/Pagination/Modulepagination";
import { moduleSearchInputAction, moduleListPageinputAction} from "../../actions/moduleListAction";
import Loader from "../../component/loaderComponent/Loader";
import { buttonHandleAction } from "../../actions/trainingAction";
import { tutorialSearchInputAction,tutorialListPageinputAction } from "../../actions/trainingAction";
import { HTTP_STATUS } from "../../constants/httpstatus/HttpsStatus";
import { Modal } from "react-bootstrap";
import PoppupThumbnail from "../../component/PoppupThumbnail";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

const ProductTraining = () => {
  const ButtonData = useSelector((state) => state.activecomponent);
  const searchData = useSelector((state) => state.tutorialSearch);
  const moduleSearchData = useSelector((state) => state.moduleSearch.searchvaluedata);
  const modulePageData = useSelector((state) => state?.modulePage);
  const tutorialPageData = useSelector((state) => state?.tutorialPage);
  const [activeButton, setActiveButton] = useState(ButtonData?.activebtn?.activebtn);
  const [showComponent1, setShowComponent1] = useState(ButtonData?.activebtn?.training);
  const [showComponent2, setShowComponent2] = useState(ButtonData?.activebtn?.module);
  const [searchvalue, setSearchvalue] = useState(searchData?.searchvaluedata?.searchdata);
  const [selectedCheckbox, setSelectedCheckbox] = useState(searchData?.searchvaluedata?.type);
  const [tutorialListData, settutorialList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modulelist, setModuleList] = useState([]);
  const [isLoadings, setIsLoadings] = useState(false);
  const [count, setCount] = useState(1);
  const [count_mod, setCountmod] = useState(1);
  const [page, setPage] = useState(tutorialPageData?.page);
  const [modulelistPage, setModulelistPage] = useState(modulePageData?.page);
  const [startIndex, setStartIndex] = useState(1);
  const [startmodIndex, setStartIndex_mod] = useState(1);
  const [searchInputValue, setSearchInputValue] = useState(moduleSearchData?.searchdata);
  const [Vehiclename, setVehiclename] = useState(moduleSearchData?.vehicle);
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");

  useEffect(() => {
    setSearchInputValue(moduleSearchData?.searchdata);
    setVehiclename(moduleSearchData?.vehicle);
    handleChangeLanguage(language);
  }, [moduleSearchData]);

  useEffect(() => {
    if(searchvalue.length === 0){
      tutorialData();
    }
  }, [searchvalue])

  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  var paginationCount = 15;
  const onAddmodule = () => {
    navigate("/addeditmodule");
  };
  const onaddcontent = () => {
    navigate("/addcontent");
  };
  const navigate = useNavigate();

  const handlePageChange = (event, value) => {
    dispatch(tutorialListPageinputAction(value));
    setPage(value);
  };
  const handlePageChangemod = (event, value) => {
    dispatch(moduleListPageinputAction(value));
    setModulelistPage(value);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    tutorialData();
    ModuleListData();
  }, [page, modulelistPage]);

  const handleEditButton = (Id) => {
    window.scroll(0, 0);
    const module_id = safeEncode(Id);
    navigate(`/editmodule/${module_id}`);
  };
  const handleVehiclelistInput = (evt) => {
    const value = evt.target.value;
    setModulelistPage(1)
    setVehiclename(value.replace(/^ +/gm, ""));
    var seardata = {
      searchdata: searchInputValue,
      vehicle: value,
    };
    dispatch(moduleSearchInputAction(seardata));
  };

  const handleModuleSearchInput = (evt) => {
    const value = evt.target.value;
    setModulelistPage(1)
    setSearchInputValue(value.replace(/^ +/gm, ""));
    var seardata = {
      searchdata: value,
      vehicle: Vehiclename,
    };
    dispatch(moduleSearchInputAction(seardata));
    if (value.length === 0) {
      setIsLoading(true);
      reloadModuleData();
      onmoduleSearch();
    }
  };

  const reloadModuleData = async () => {
    setVehiclename("");
    setSearchInputValue("");
    try {
      await ModuleListData();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_TUTORIALS) && hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_MODULE)) {
      // Redirect to module and update state
      handleComponent2Click("Modules");
    }
  }, []);

  const handleComponent1Click = (index) => {
    setActiveButton(index);
    setShowComponent1(true);
    setShowComponent2(false);
    tutorialData();
    var btnvalue = {
      activebtn: index,
      training: true,
      module: false,
    };
    dispatch(buttonHandleAction(btnvalue));
  };

  const handleComponent2Click = (index) => {
    setActiveButton(index);
    setShowComponent1(false);
    setShowComponent2(true);
    const searchInputData = {
      searchdata: "",
      vehicle: "",
    };
    dispatch(moduleSearchInputAction(searchInputData));
    var btnvalue = {
      activebtn: index,
      training: false,
      module: true,
    };
    dispatch(buttonHandleAction(btnvalue));
    ModuleListData();
  };

  const handleEditClick = (Id) => {
    const encodeid = safeEncode(Id);
    navigate(`/editcontent/${encodeid}`);
  };

  useEffect(() => {
    if (page === 1) {
      // Only call tutorialData when page is 1
      tutorialData(selectedCheckbox);
    }
  }, [selectedCheckbox]);

  const handleFilterTypeCheckboxChange = (event) => {
    setPage(1)
    const checkboxValue = event.target.value;
    setSelectedCheckbox(checkboxValue);
    var seardata = {
      searchdata: "",
      type: checkboxValue,
    };
    dispatch(tutorialSearchInputAction(seardata));
  };

  const handleChange = (evt) => {
    const value = evt.target.value;
    setSearchvalue(value.replace(/^ +/gm, ""));
    var seardata = {
      searchdata: value,
      type: selectedCheckbox,
    };
    dispatch(tutorialSearchInputAction(seardata));
  };

  async function tutorialData(type) {
    if (!hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_TUTORIALS)){
     setIsLoading(false);
     return;
    }
    setIsLoading(true);
    const newStartIndex = (page - 1) * paginationCount + 1;
    setStartIndex(newStartIndex);
    if( searchData==="" ){
      var response = await dispatch(tutorialListAction(page, type));
    }else{
      var response = await dispatch(tutorialListAction(page, selectedCheckbox ? selectedCheckbox : type, searchvalue));
    }
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response?.data?.data?.count / paginationCount) ?? 1);
      settutorialList(response?.data?.data?.results);
      setIsLoading(false);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  }

  async function filterSearch(type, search) {
    setPage(1)
    if (search === "") {
      NotificationManager.error("Please enter value");
      return false;
    }
    setIsLoading(true);
    let response = await dispatch(tutorialListAction(1, type, search));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCount(Math.ceil(response?.data?.data?.count / paginationCount));
      settutorialList(response?.data?.data?.results);
      setIsLoading(false);
    }else if(response === undefined){
      setIsLoading(false);
    }
  }

  async function ModuleListData() {
    if (!hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_MODULE)){
      setIsLoading(false);
      return;
     }
    setIsLoadings(true);
    const newStartIndex_mod = (modulelistPage - 1) * paginationCount + 1;
    setStartIndex_mod(newStartIndex_mod);
    let response = await dispatch(moduleListAction(modulelistPage,Vehiclename,searchInputValue));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCountmod(Math.ceil(response?.data?.data?.count / paginationCount));
      setModuleList(response?.data?.data?.results);
      setIsLoadings(false);
    } else if (response === undefined) {
      setIsLoadings(false);
    }
  }

  async function onmoduleSearch(vehicle_id, searchinput) {
    setIsLoading(true);
    let response = await dispatch(moduleListAction(modulelistPage, vehicle_id, searchinput));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCountmod(Math.ceil(response?.data?.data?.count / paginationCount));
      setModuleList(response?.data?.data?.results);
      setIsLoading(false);
    } else if (response === undefined) {
      setIsLoadings(false);
    }
  }
  const [showThumbnail,setShowThumbnail] = useState(false);
  const [attachmenturl,setAttachmenturl] = useState("");
  const [attachmentType,setAttachmentType] = useState("");

  const OpenThumbnailPopup  = (attachment,attachment_type) =>{
    if(attachment_type.toLowerCase() === "pdf"){
      window.open(attachment, '_blank');
      NotificationManager.success("Pdf downloaded successfully !");
    }
    else{
      setShowThumbnail(true);
      setAttachmenturl(attachment);
      setAttachmentType(attachment_type);
    }

  }

  const CloseThumbnailPopup  = () =>{
    setShowThumbnail(false);
  }
  const ResetData  = () =>{
    setSearchvalue("");
    setSelectedCheckbox("");
    setVehiclename("");
    setSearchInputValue("");
    var seardata1 = {
      searchdata: "",
      type: "",
    };
    dispatch(tutorialSearchInputAction(seardata1));
    var seardata2 = {
      searchdata: "",
      vehicle: "",
    };
    dispatch(moduleSearchInputAction(seardata2));
  }
  useEffect(() => {
    ResetData();
  }, [showComponent1,showComponent2]);

  return (
    <div className="ProductTraining_containers">
      <div className="ProductTraining_container">
        <div className="ProductTrainingcontent">
          <div className="header_border">
            {showComponent1 && (
              <p className="pgm-list-header-text">TVS &gt; {t('tutorialtraining.tutorial')}</p>
            )}
            {showComponent2 && (
              <p className="pgm-list-header-text">TVS &gt; {t('training_module.trainingmodule')}</p>
            )}
          </div>
          <div className="ProductTraining_buttons_container">
            <div className="ProductTraining_buttons">
              <div className="training_module">
              {hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_TUTORIALS) && (
                <button
                  className={ activeButton === "Tutorial" ? "active ProductTraining_Tutorial_TutorialShooting" : "ProductTraining_ModulesTutorialShooting"}
                  onClick={() => handleComponent1Click("Tutorial")}
                >
                  {t('tutorialtraining.tutorialtroubleshooting')}
                </button>
              )}
              {hasPermission(PERMISSIONS.CAN_VIEW_TRAINING_MODULE) && (
                <button
                  className={ activeButton === "Modules" ? "active ProductTraining_Tutorial" : "ProductTraining_Modules"}
                  onClick={() => handleComponent2Click("Modules")}
                >
                  {t('tutorialtraining.modules')}
                </button>
              )}
              </div>
              <div className="content_module">
              {showComponent2 ? (
                hasPermission(PERMISSIONS.CAN_CREATE_TRAINING_MODULE) && (
                  <button
                    className="ProductTraining_AddTutorial"
                    onClick={onAddmodule}
                  >
                    {t('tutorialtraining.addmodule')}
                  </button>
                )
              ) : (
                hasPermission(PERMISSIONS.CAN_CREATE_TRAINING_TUTORIAL) && (
                  <button
                  className="ProductTraining_AddTutorial"
                  onClick={onaddcontent}
                  >
                  {t('tutorialtraining.addcontent')}
                  </button>
                )
              )}
              </div>
            </div>
          </div>
          {isLoading ? (
            <Loader />
          ) : (
            <>
              {showComponent1 && (
                <ProductTrainings
                  tutorialListData={tutorialListData}
                  filterSearch={filterSearch}
                  startIndex={startIndex}
                  tutorialData={tutorialData}
                  page={page}
                  searchvalue={searchvalue}
                  selectedCheckbox={selectedCheckbox}
                  handleEditClick={handleEditClick}
                  handleFilterTypeCheckboxChange={handleFilterTypeCheckboxChange}
                  handleChange={handleChange}
                  isLoading={isLoading}
                  OpenThumbnailPopup={OpenThumbnailPopup}
                />
              )}

              {showComponent2 && (
                <Module
                  modulelist={modulelist}
                  onmoduleSearch={onmoduleSearch}
                  startIndex={startmodIndex}
                  handleEditButton={handleEditButton}
                  handleModuleSearchInput={handleModuleSearchInput}
                  handleVehiclelistInput={handleVehiclelistInput}
                  searchInputValue={searchInputValue}
                  Vehiclename={Vehiclename}
                />
              )}
              <div>
                {showComponent1 && (
                  <Pagination
                    count={count}
                    page={page}
                    handlePageChange={handlePageChange}
                  />
                )}
                {showComponent2 && (
                  <Modulepagination
                    count={count_mod}
                    page={modulelistPage}
                    handlePageChange={handlePageChangemod}
                  />
                )}
              </div>
            </>
          )}
        </div>
        <Modal
          className="expertise-modal montserrat-font"
          show={showThumbnail}
          onHide={CloseThumbnailPopup}
        >
          <Modal.Body className="p-0">
            <PoppupThumbnail
              CloseThumbnailPopup ={CloseThumbnailPopup}
              attachmenturl={attachmenturl}
              attachmentType={attachmentType}
            />
          </Modal.Body>
        </Modal>
      </div>
      <div className="footer_div">
        <Footer />
      </div>
    </div>
  );
};

export default ProductTraining;
